import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-timeline-monitor',
  templateUrl: './timeline-monitor.component.html',
  styleUrls: ['./timeline-monitor.component.scss']
})
export class TimelineMonitorComponent implements OnInit, AfterViewChecked {

  dataTimeline: any[][] = [
    ['Tractor 1541', 'Monterrey MX - SC USA', new Date(2021, 11, 30), new Date(2022, 0, 5)],
    ['Tractor 1542', 'Monterrey MX - TX USA', new Date(2021, 11, 30), new Date(2022, 0, 6)],
    ['Tractor 1543', 'Monterrey MX - LA USA', new Date(2021, 11, 30), new Date(2022, 0, 7)],
    ['Tractor 1544', 'Monterrey MX - NY USA', new Date(2021, 11, 30), new Date(2022, 0, 7)]
  ];
  optionsTimeline = {
    language: 'es'
  };
  columnsTimeline = [
    {
      type: 'string',
      id: 'Term'
    },
    {
      type: 'string',
      id: 'Name'
    },
    {
      type: 'date',
      id: 'Start'
    },
    {
      type: 'date',
      id: 'End'
    }
  ]

  constructor(
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

}
